import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualSection from '../../components/manual/ManualSection';
import ManualStep from '../../components/manual/ManualStep';
import ManualAlert from '../../components/manual/ManualAlert';

function ManualLogsPage() {
  return (
    <div className="manual-page">
      <ManualBreadcrumb items={[{ label: 'Logs do Sistema' }]} />

      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-activity me-3"></i>
          Logs do Sistema
        </h1>
        <p className="manual-subtitle">
          Auditoria de ações, filtros avançados e monitoramento em tempo real
        </p>
      </div>

      <ManualAlert type="important">
        O acesso a esta área depende da permissão <code>admin.logs</code>.
      </ManualAlert>

      <ManualSection icon="bi-funnel" title="Filtros Disponíveis">
        <p>
          A tela permite filtrar registros por período, usuário, ação, entidade, IP e termos de busca.
          Também há filtros rápidos para erros e eventos críticos.
        </p>
      </ManualSection>

      <ManualSection icon="bi-graph-up" title="Indicadores e Gráficos">
        <p>
          Além da tabela de eventos, o painel de logs exibe cards de estatísticas e gráficos
          para facilitar análise operacional e auditoria.
        </p>
      </ManualSection>

      <ManualSection icon="bi-broadcast" title="Atualização em Tempo Real">
        <ManualStep number="1" title="Ative o modo Tempo Real">
          Use o botão <strong>Tempo Real</strong> no topo da tela.
        </ManualStep>

        <ManualStep number="2" title="Monitore novos eventos">
          Novos logs chegam automaticamente; quando necessário, use o botão de atualização para sincronizar.
        </ManualStep>
      </ManualSection>
    </div>
  );
}

export default ManualLogsPage;
